import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SettingsService } from '../services/settings.service';
import { UserSettings } from '../models/settings.model';

export const HomeResolver: ResolveFn<UserSettings | null> = () => {
  const settingsService = inject(SettingsService);
  const router = inject(Router);

  return settingsService.getSettings().pipe(
    catchError(error => {
      console.error('Failed to load settings:', error);
      router.navigate(['/error']);
      return of(null);
    })
  );
};
